import type { SUPPORTED_SOCIAL_MEDIA } from 'constant'

import styled, { css } from 'styled-components'

import { COLOR, SHARE_BUTTON_STYLES } from 'styles/constants'

export type ShareButtonProps = {
  onClick?: () => void
  disable?: boolean
  type: typeof SUPPORTED_SOCIAL_MEDIA[number]
}
const ShareButtonStyled = styled.button<{
  platform: typeof SUPPORTED_SOCIAL_MEDIA[number]
  disable?: boolean
}>`
  width: 30px;
  height: 30px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 50%;
  overflow: hidden;
  background-color: #ffffff;
  cursor: pointer;
  outline: none;
  text-indent: -9999px;
  position: relative;

  &::before {
    mask-size: 30px;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    ${({ platform }) =>
      SHARE_BUTTON_STYLES[platform] &&
      css`
        mask-image: url('${SHARE_BUTTON_STYLES[platform].icon}');
        background-color: ${SHARE_BUTTON_STYLES[platform].color};
      `}}
  }

  ${({ disable }) =>
    disable &&
    css`
      // override bootstrap button styles
      cursor: not-allowed !important;

      &::before {
        background-color: ${COLOR.GREY_LV5};
      }
    `}
`

export const ShareButton: React.FC<ShareButtonProps> = ({ onClick, type, disable = false }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()

    onClick?.()
  }

  return (
    <ShareButtonStyled onClick={handleClick} platform={type} disable={disable}>
      {type}
    </ShareButtonStyled>
  )
}
